
import { computed, defineComponent, ref } from 'vue'
import { useI18n } from 'vue-i18n';
export default defineComponent({
    props: {
        visible: Boolean
    },
    emits: [ 'update:visible', 'submited' ],
    computed: {
        typeInput(): string {
            return this.showPassword ? 'text' : 'password';
        }
    },
    setup(props, { emit }) {
        const { t } = useI18n();
        const token = ref("");
        const isVisible = computed({
            get() {
                return props.visible;
            },
            set(val: boolean) {
                emit('update:visible', val);
            }
        })

        const submit = () => {
            emit('submited', token.value);
            token.value = "";
        }

        return {
            token,
            isVisible,
            submit,
            t
        }
    },
    data() {
        return {
            showPassword: false
        }
    }
})
